import { useTheme } from '@/contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';

export default function ThemeToggle() {
  const { toggleTheme, isDark } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="fixed top-24 right-6 z-40 p-3 bg-[#0A0A0A] dark:bg-white/10 border border-white/10 dark:border-white/20 rounded-full hover:bg-[#D4AF37]/10 dark:hover:bg-white/20 transition-all duration-300 group"
      aria-label="Alternar tema"
      title={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
    >
      <div className="relative w-6 h-6 flex items-center justify-center">
        <Sun 
          className={`absolute w-4 h-4 text-[#D4AF37] transition-all duration-300 ${
            isDark ? 'opacity-0 scale-0' : 'opacity-100 scale-100'
          }`}
          strokeWidth={2}
        />
        <Moon 
          className={`absolute w-4 h-4 text-[#D4AF37] transition-all duration-300 ${
            isDark ? 'opacity-100 scale-100' : 'opacity-0 scale-0'
          }`}
          strokeWidth={2}
        />
      </div>
    </button>
  );
}
